import { render, staticRenderFns } from "./BlocForm.vue?vue&type=template&id=0ad45b43"
import script from "./BlocForm.vue?vue&type=script&lang=js"
export * from "./BlocForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ad45b43')) {
      api.createRecord('0ad45b43', component.options)
    } else {
      api.reload('0ad45b43', component.options)
    }
    module.hot.accept("./BlocForm.vue?vue&type=template&id=0ad45b43", function () {
      api.rerender('0ad45b43', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/referentiel/blocs/BlocForm.vue"
export default component.exports